{
  "markread": "пометить как прочитанные",
  "newest": "свежие",
  "unread": "непрочитанные",
  "starred": "отмеченные",
  "tags": "Метки",
  "alltags": "все метки",
  "timestamp": "{0,date} {0,time}",
  "hours": "{0,plural,one {1 час},other {# часов}} назад",
  "minutes": "{0,plural,one {1 минуту},other {# минут}} назад",
  "seconds": "{0,plural,one {1 секунду},other {# секунд}} назад",
  "star": "отметить",
  "unstar": "снять отметку",
  "mark": "прочитано",
  "unmark": "не прочитано",
  "load_img": "загрузить изображения",
  "open_window": "открыть",
  "searchbutton": "Поиск",
  "sources": "Источники",
  "source_add": "добавить источник",
  "source_opml": "или импортировать файл OPML, например из Google Reader",
  "source_export": "экспорт источников",
  "source_edit": "править",
  "source_delete": "удалить",
  "source_warn": "действительно удалить этот источник?",
  "source_new": "новый несохраненный источник",
  "source_title": "Название",
  "source_tags": "Метки",
  "source_comma": "раделяйте запятой",
  "source_select": "выберите тип источника",
  "source_type": "Тип",
  "source_save": "сохранить",
  "source_cancel": "отмена",
  "source_saved": "сохранено",
  "no_entries": "записей не найдено",
  "more": "еще",
  "login": "вход",
  "login_username": "имя",
  "login_password": "пароль",
  "no_title": "без названия",
  "searchremove": "Скрыть поиск"
}
